module.exports = __webpack_public_path__ + "img/burgerking.58e0f2d8.png";